<template>    
  <form class="po-form" v-on:submit.prevent="authenticate">
    <div class="po-form__header">
        <a href="/"><img src="../assets/img/logo.svg" alt="logo"></a>
        <a
          class="po-form__back-link"
          v-bind:href="this.$parent.mainSiteURL"
        >
          Вернуться на сайт
        </a>
    </div>
    <div class="po-form__title">Личный кабинет</div>
    <div class="po-form__description">
        Укажите Ваш e-mail и пароль для доступа к личному кабинету и просмотру истории заказов
    </div>
    <div class="form__row">
      <div
        class="po-form__control"
        v-bind:class="{
          'po-form__control_conformed': $v.loginForm.email.$dirty && !$v.loginForm.email.$invalid,
          'po-form__control_rejected': $v.loginForm.email.$error
        }"
      >
        <label class="po-form__label" for="email">Email</label>
        <input
          id="email"
          type="text"
          class="po-form__input"
          v-model="$v.loginForm.email.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.loginForm.email.$dirty && !$v.loginForm.email.required"
        >
          Это поле необходимо заполнить
        </div>
      </div>
    </div>
    <div class="form__row">
      <div
        class="po-form__control"
        v-bind:class="{
          'po-form__control_conformed': $v.loginForm.password.$dirty && !$v.loginForm.password.$invalid,
          'po-form__control_rejected': $v.loginForm.password.$error
        }"
      >
        <label class="po-form__label" for="pass">Пароль</label>
        <input
          id="pass"
          type="password"
          class="po-form__input"
          v-model="$v.loginForm.password.$model"
        >
        <div
          class="po-form__error"
          v-if="$v.loginForm.password.$dirty && !$v.loginForm.password.required"
        >
          Это поле необходимо заполнить
        </div>
      </div>
    </div>
    <div class="form__error" v-if="error">
      Логин или пароль неверны
    </div>
    <div class="form__row form__row_mt-20">
        <a href="/reset-password" class="text_medium">Забыли пароль?</a>
    </div>
    <div class="form__row form__row_between">
        <button type="submit" class="e-button">Войти</button>
        <a tag="div" href="/registration" class="e-button e-button_preview">Зарегистрироваться</a>
    </div>
    <div class="form__policy po-form__policy" v-if="this.$parent.config" v-html="this.$parent.config.form_politics">
    </div>
  </form>
</template>
<script>

import { required } from 'vuelidate/lib/validators'

import { Auth } from '@/api/auth';

export default {
  name: 'login',
  data: function() {
    return {
      loginForm: {
        email: null,
        password: null,
      },
      error: false
    }
  },
  validations: {
    loginForm: {
      email: {
        required,
      },
      password: {
        required
      },
    }
  },
  methods: {
    authenticate: function (){
      this.error = false;
      this.$v.$touch();
      if(!this.$v.$invalid) {
        this.loginForm.email = this.loginForm.email.toLowerCase();
        Auth.login(this.loginForm).then(res => {
          if(res.status == 200){
            this.$store.commit('setAuthUser', res.data.token);
            this.$router.go({name: 'home'});
          } else if(res.status == 400) {
            this.error = true;
          }
        });
      }
    },
  },
}
</script>